import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import Select from "react-select";
import { useFormik } from "formik";
import * as Yup from "yup";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

// Custom styles
const SelectcustomStyles = {
  control: (base) => ({
    ...base,
    minHeight: 33.1,
  }),
  indicatorsContainer: (base) => ({
    ...base,
    padding: "0",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "2px 8px",
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: "2px 8px",
  }),
};

const financialYearOptions = [
  { value: "2025-2026", label: "2025-2026" },
];


const SelfAppraisal = () => {
  const formik = useFormik({
    initialValues: {
      financialYear: "",
    },
    validationSchema: Yup.object({
      financialYear: Yup.string().required("Financial Year is required"),
    }),
    onSubmit: (values) => {
      console.log("Form submitted:", values);
    },
  });

  return (
    <div className="page-content">
      <Container fluid className="mt-4">
        <Breadcrumbs title="Performance" breadcrumbItem="Self Appraisal" />
        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">
                <Col xs={12} md={4}>
                  <FormGroup>
                    <Label>
                      Employee Code <span className="text-danger">*</span>
                    </Label>
                    <Input type="text" value="0" readOnly />
                  </FormGroup>
                </Col>
                <Col xs={12} md={4}>
                  <FormGroup>
                    <Label>
                      Employee Name <span className="text-danger">*</span>
                    </Label>
                    <Input type="text" value="AES ADMIN" readOnly />
                  </FormGroup>
                </Col>
                <Col xs={12} md={4}>
                  <FormGroup>
                    <Label>
                      Category <span className="text-danger">*</span>
                    </Label>
                    <Input type="text" value="Admin" readOnly />
                  </FormGroup>
                </Col>
                <Col xs={12} md={4}>
                  <FormGroup>
                    <Label>
                      Designation <span className="text-danger">*</span>
                    </Label>
                    <Input type="text" value="General admin" readOnly />
                  </FormGroup>
                </Col>
                <Col xs={12} md={4}>
                  <FormGroup>
                    <Label>
                      Department <span className="text-danger">*</span>
                    </Label>
                    <Input type="text" value="Admin" readOnly />
                  </FormGroup>
                </Col>
                <Col xs={12} md={4}>
                  <FormGroup>
                    <Label>
                      Financial Year <span className="text-danger">*</span>
                    </Label>
                    <Select
                      name="financialYear"
                      options={financialYearOptions}
                      placeholder="--Select--"
                      value={financialYearOptions.find(
                        (opt) => opt.value === formik.values.financialYear
                      )}
                      onChange={(option) =>
                        formik.setFieldValue("financialYear", option?.value || "")
                      }
                      onBlur={formik.handleBlur}
                      styles={SelectcustomStyles}
                      className="hrms-select"
                      classNamePrefix="hrms-select"
                    />
                    {formik.touched.financialYear && formik.errors.financialYear && (
                      <div className="text-danger mt-1">
                        {formik.errors.financialYear}
                      </div>
                    )}
                  </FormGroup>
                </Col>

                {/* Buttons */}
                <Col xs={12}>
                  <div className="d-flex justify-content-end flex-wrap">
                    <Button type="submit" className="btn button-search me-2">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                    <Button type="submit" className="btn button-submit me-2">
                    <i className="fas fa-paper-plane me-1" /> Submit
                  </Button>
                    <Button
                      className="btn button-cancel"
                      type="button"
                      onClick={formik.handleReset}
                    >
                      <i className="fas fa-sync me-1" /> Cancel
                    </Button>
                  </div>
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

        {/* rating table */}
        <Card>
        <div className="ratingtable">
          <Row className="align-items-center">
            <Col xs={12} md={3}><strong>Rating</strong></Col>
            <Col xs={12} md={3}>Fixed Weightage : <strong>10.00</strong></Col>
            <Col xs={12} md={3}>Achieved Weightage : <strong>0.00</strong></Col>
            <Col xs={12} md={3}>Reviewed Weightage : <strong>0.00</strong></Col>
          </Row>
        </div>
        <CardBody className="p-0">
          <div className="table-responsive">
            <table className="table table-bordered m-0 text-center align-middle" style={{ borderColor: "#4da3ff" }}>
              <thead style={{ backgroundColor: "#f6f9ff" }}>
                <tr>
                  <th>KPI Factors</th>
                  <th>Fixed Weightage</th>
                  <th>Achieved Weightage</th>
                  <th>Remarks</th>
                  <th>Reviewed Weightage</th>
                  <th>Reviewed Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-start">Rating Creation</td>
                  <td>10.00</td>
                  <td>
                    <Input type="number" defaultValue="0.00" />
                  </td>
                  <td>
                    <Input type="text" />
                  </td>
                  <td>
                    <Input type="number" defaultValue="0.00" />
                  </td>
                  <td>
                    <Input type="text" defaultValue="-" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </CardBody>
      </Card>
      </Container>
    </div>
  );
};

export default SelfAppraisal;
